import {
  decomposedFieldSocketType,
  decomposedFieldsFor,
} from "../../entity-decomposition/entityDecompositions";
import type { DynamicSocketDefinition } from "./socketDefinition";

/**
 * Output sockets of the Decompose Entity step: one per field the
 * `ENTITY_DECOMPOSITIONS` map declares for `config.entityType`. No entity type
 * (nothing wired yet) means no outputs. Every output is optional — a field
 * that is null on the row leaves its socket unset.
 */
export function generateDecomposeEntityOutputSockets(
  config: Record<string, unknown>,
): DynamicSocketDefinition[] {
  return decomposedFieldsFor(config.entityType).map((field) => ({
    id: field.socketId,
    name: field.label,
    type: decomposedFieldSocketType(field.format),
    required: false,
    description: field.description,
  }));
}
